import {createAction, createReducer} from '@reduxjs/toolkit';

export const initialState = {
    error: '',
    loading: false,
};

export const setEditStepLoading = createAction<boolean>('CHECKOUT@SET_EDIT_STEP_LOADING');

export const setEditStepError = createAction<string>('CHECKOUT@SET_EDIT_STEP_ERROR');

/**
 * Edit step
 *
 * @return {{loading: boolean, error: string}} - new state
 */
export const editStep = createReducer(initialState, builder =>
    builder
        .addCase(setEditStepLoading, (state, action) => ({...state, loading: action.payload}))
        .addCase(setEditStepError, (state, action) => ({...state, error: action.payload})),
);
